import React from 'react';
import { CircleHelp } from 'lucide-react';
import Button from './Button';
import { useButtonLegendDrawer } from '../../context/ButtonLegendDrawerContext';
import { LegendItem } from '../drawer/ButtonLegendContent';

interface ButtonLegendCtaProps {
    items: LegendItem[];
    title?: string;
}

const ButtonLegendCta: React.FC<ButtonLegendCtaProps> = ({ items, title = 'Button Guide' }) => {
    const { showLegend } = useButtonLegendDrawer();

    return (
        <Button
            type="button"
            variant="secondary"
            icon={CircleHelp}
            onClick={() => showLegend(items, title)}
        >
            Button Guide
        </Button>
    );
};

export default ButtonLegendCta;
